 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    // CM perf 2026-10 (INP): antes, CUALQUIER cambio dentro del carrito (abrir, cerrar, cambiar cantidad,
    // textos de otras apps) volvía a descargar la página ENTERA (window.location.href, ~800 KB en la PDP)
    // y la parseaba con DOMParser en el hilo principal, 250 ms después de cada toque.
    // Ahora: (1) cambios solo de atributos (abrir/cerrar) se ignoran; (2) si la lista de recomendados
    // está vacía en el servidor (sin colección configurada en el tema), no hay nada que refrescar:
    // solo se re-inserta el contenedor local, sin red; (3) si hay recomendados, se mantiene el
    // refresco de la página, pero solo tras cambios reales del contenido y en tiempo ocioso.
    function upsellListIsEmpty() {
      var w = document.querySelector('#cart-drawer-upsell-wrapper')
      return !w || !w.querySelector('.cart-drawer-upsell-list li')
    }
    var upsellStaticEmpty = upsellListIsEmpty() && document.querySelector('#cart-drawer-upsell-wrapper[data-cm-upsell-static-empty]')
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1) }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        // Abrir/cerrar el carrito solo cambia atributos: no hay productos nuevos que excluir.
        var contentChanged = false
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'childList') { contentChanged = true; break }
        }
        if (!contentChanged) return
        if (timer) clearTimeout(timer)

        timer = setTimeout(() => {
          if (upsellStaticEmpty) {
            // Sin recomendados configurados: el contenido del servidor sería idéntico (lista vacía).
            insertSectionCartDrawer()
            return
          }
          idle(async () => {
            const respoonse = await fetch(window.location.href)
            const text = await respoonse.text()
            const newDocument = new DOMParser().parseFromString(text, 'text/html')

            document.querySelector('#cart-drawer-upsell-wrapper')
              .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
          })
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();